import React from 'react';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { FinancingEmptyDecorator } from 'client/site-modules/financing/decorators/financing-empty-decorator';
import { PreQualifyCheck } from 'client/site-modules/financing/components/prequalify-check/prequalify-check';
import { FinancingDecoratorFactoryPreload } from './financing-model-preloader';

export const PrequalifyCheck = pageDefinition({
  name: 'financing_prequalify_check',
  category: 'financing',
  decorator: FinancingEmptyDecorator,
  preload: FinancingDecoratorFactoryPreload,
  component: options => <PreQualifyCheck vin={options.match.params.vin} />,
});
